import { useTranslation } from 'react-i18next';
import { Modal } from '~/components/overlays';
import { Button } from '~/components/ui';

type Props = {
  isOpen: boolean;
  isSaving: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function OrganizationScopeConfirmDialog({
  isOpen,
  isSaving,
  onConfirm,
  onCancel,
}: Props) {
  const { t } = useTranslation('my-product');

  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <div className="bg-neut-bg-alt rounded-lg p-6 w-full max-w-sm">
        <h2
          id="Modal-title"
          data-testid="scope-confirm-dialog-title"
          className="text-base font-semibold text-neut-prim mb-2"
        >
          {t('edit_product.scope.confirm_dialog.title')}
        </h2>
        <p className="text-sm text-neut-sec mb-4">
          {t('edit_product.scope.confirm_dialog.message')}
        </p>

        <div className="flex gap-3">
          <Button
            size="sm"
            variant="accent"
            onClick={onCancel}
            disabled={isSaving}
            data-testid="scope-cancel-organization"
          >
            {t('edit_product.scope.confirm_dialog.cancel')}
          </Button>
          <Button
            size="sm"
            onClick={onConfirm}
            disabled={isSaving}
            data-testid="scope-confirm-organization"
          >
            {t('edit_product.scope.confirm_dialog.confirm')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
